// @flow
import { StaffActionTypes } from './constants';

type StaffAction = { type: string, payload: {} | string };

// common success
export const staffApiResponseSuccess = (actionType: string, data: any): StaffAction => ({
    type: StaffActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const staffApiResponseError = (actionType: string, error: string): StaffAction => ({
    type: StaffActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listEmployees = (): StaffAction => ({
    type: StaffActionTypes.LIST_EMPLOYEES,
    payload: {},
});
export const getEmployee = (id: string): StaffAction => ({
    type: StaffActionTypes.GET_EMPLOYEE,
    payload: { id },
});

export const addEmployee = (employee:any):StaffAction=>({
    type:StaffActionTypes.ADD_EMPLOYEE,
    payload:employee
})
export const updateEmployee = (employee:any):StaffAction=>({
    type:StaffActionTypes.UPDATE_EMPLOYEE,
    payload:employee
})
export const deleteEmployee = (id:string):StaffAction=>({
    type:StaffActionTypes.DELETE_EMPLOYEE,
    payload:{id}
})

export const resetEmployee = (): StaffAction => ({
    type: StaffActionTypes.RESET,
    payload: {},
});

